class FilterActions {
    constructor() {
        if (window.location.href.search(/filter/g) <= -1) {
            this.filterForm = document.querySelector('.qm-filter-bar');
            this.datatablesContainer = document.querySelector('.datatables-container');
            this.filterEndpoint = this.datatablesContainer.dataset.endpointFiltershow;
        }
    }

    /*
    * fetch filter for the first time
    * */
    fetchFilter = () => {
        if (!this.filterEndpoint) {
            return;
        }
        $.ajax({
            url: this.filterEndpoint,
            type: 'POST',
            dataType: 'json',
            success: res => {
                this.initFilter(res, 0);
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                console.error(`${errorThrown}`);
                console.error(`${textStatus}`);
            }
        });
    }

    createSearchInput = () => {
        let search = {
            wrapper: document.createElement('div'),
            input: document.createElement('input')
        }

        search.input.setAttribute('id', 'filter-search');
        search.input.setAttribute('type', 'text');
        search.input.setAttribute('autocomplete', 'off');
        search.input.setAttribute('placeholder', 'Linien-Suche: z. B. RE2');

        search.wrapper.classList.add('qm-filter__search');

        return {input: search.input, wrapper: search.wrapper}
    }

    checkInputType = target => {
        switch (target) {
            case 'year':
                return 'radio';
                break;
            case 'quarter':
            case 'evu':
            case 'region':
            case 'product_type':
            case 'lines':
                return 'checkbox';
                break;
            case 'complexity':
                return 'checkbox';
                break;
        }
    }

    initFilter = (obj, filterIndex) => {
        obj.forEach((object, itemIndex) => {
            let filter = this.filterForm.querySelector(`#filter-${object.target}`),
                filterContent = filter.querySelector('.qm-filter__dropdown__content'),
                inputType = this.checkInputType(object.target),
                complexity = (object.target === 'complexity');

            filterContent.innerHTML = '';
            filter.setAttribute('data-index', itemIndex);

            if (object.target === 'lines') {
                let search = this.createSearchInput();
                filterContent.prepend(search.wrapper);
                filterContent.querySelector('.qm-filter__search').prepend(search.input)
            }

            object.items.forEach(item => {
                let strippedTitle = item.title.toString().replace(/[\/().\s]/g, '');

                // setup filter
                let inputSettings = {
                        settings: {
                            status: item.status,
                            type: inputType,
                            name: object.target,
                            value: item.title,
                            dataType: object.target,
                            classes: ['main-filter', object.target, item.status],
                            id: `${object.target}-${strippedTitle}`
                        }
                    },
                    divSettings = {
                        settings: {
                            classes: ['main-dropdown', 'qm-form-group', `qm-form-group--${(inputType === 'checkbox') ? 'check' : 'radio'}`, item.status],
                            id: ''
                        }
                    },
                    labelSettings = {
                        settings: {
                            classes: ['main-label'],
                            id: `${object.target}-${strippedTitle}`
                        }
                    },
                    iconSpanSerttings = {
                        settings: {
                            elementType: 'span',
                            classes: ['icon'],
                            id: '',
                            text: new CreateNewElement().text('')
                        }
                    },
                    textSpanSettings = {
                        settings: {
                            elementType: 'span',
                            classes: ['text-content'],
                            id: '',
                            text: new CreateNewElement().text((complexity) ? this.rewriteComplexity(item.title) : item.title)
                        }
                    },
                    filterInputElement = new CreateNewElement().input(inputSettings.settings),
                    mainDropdownWrapper = new CreateNewElement().div(divSettings.settings),
                    filterLabelElement = new CreateNewElement().label(labelSettings.settings),
                    iconSpanElement = new CreateNewElement().custom(iconSpanSerttings.settings),
                    textSpanElement = new CreateNewElement().custom(textSpanSettings.settings);

                // create filter set
                filterLabelElement.appendChild(filterInputElement)
                filterLabelElement.appendChild(iconSpanElement)
                filterLabelElement.appendChild(textSpanElement)
                mainDropdownWrapper.appendChild(filterLabelElement)

                filterContent.appendChild(mainDropdownWrapper);
            })
        });

        Array.from(document.querySelectorAll('.main-dropdown input')).forEach((input) => {
            input.addEventListener('click', this.sendFilterOnChange);
            this.initSearch();
        })

        this.rewriteComplexity();
        this.addToggler();
    }

    updateFilter = (obj, filterIndex) => {
        obj.forEach((object, itemIndex) => {
            if (itemIndex >= filterIndex) {
                object.items.forEach((item, i) => {
                    let strippedTitle = item.title.toString().replace(/[\/().\s]/g, '');
                    let element = document.querySelector(`#${object.target}-${strippedTitle}`);

                    if (item.status === 'unavailable') {
                        if (element.classList.contains('available')) {
                            element.classList.remove('available')
                            element.parentNode.parentNode.classList.remove('available')
                            element.classList.add('unavailable')
                            element.parentNode.parentNode.classList.add('unavailable')
                            element.checked = false
                        }
                    } else {
                        if (element.classList.contains('unavailable')) {
                            element.classList.remove('unavailable')
                            element.parentNode.parentNode.classList.remove('unavailable')
                            element.classList.add('available')
                            element.parentNode.parentNode.classList.add('available')
                        }
                    }
                })
            }
        });

        this.addToggler();
    }

    addToggler() {
        let dropdown = document.querySelectorAll('.qm-filter__dropdown__content')
        Array.from(dropdown).forEach((item) => {
            let inputs = item.querySelectorAll('.main-dropdown.available input'),
                checked, region,
                createToggleContainer = () => {
                    let container = document.createElement('div');
                    container.classList.add('selectToggle')
                    item.prepend(container)
                };

            checked = region = false;
            Array.from(inputs).forEach((input) => {
                checked = (input.checked)
                region = (input.getAttribute('name') === 'region')
            })

            if (item.querySelector('.selectToggle') === null) {
                createToggleContainer();
            } else {
                item.querySelector('.selectToggle').remove()
                createToggleContainer();
            }

            if (checked) {
                item.querySelector('.selectToggle').innerHTML = (region) ? 'Region auswählen' : 'Alle abwählen'
                item.querySelector('.selectToggle').classList.add('active')
            } else {
                item.querySelector('.selectToggle').innerHTML = (region) ? 'NRW' : 'Alle auswählen'
                item.querySelector('.selectToggle').classList.remove('active')
            }
        })

        this.toggleAll()
    }

    toggleAll() {
        let dropdown = document.querySelectorAll('.qm-filter__dropdown__content')
        Array.from(dropdown).forEach((item) => {
            let inputs = item.querySelectorAll('.main-dropdown.available input'),
                region = false;
            item.querySelector('.selectToggle').addEventListener('click', function () {
                if (this.classList.contains('active')) {
                    Array.from(inputs).forEach((input, i) => {
                        if (i == (inputs.length - 1)) {
                            input.click()
                        }
                        input.checked = false
                        region = (input.getAttribute('name') === 'region')
                    })
                    this.innerHTML = (region) ? 'NRW' : 'Alle auswählen'
                    this.classList.remove('active')
                } else {
                    Array.from(inputs).forEach((input, i) => {
                        if (i == (inputs.length - 1)) {
                            input.click()
                        }
                        input.checked = true
                        region = (input.getAttribute('name') === 'region')
                    })
                    this.innerHTML = (region) ? 'Region auswählen' : 'Alle abwählen'
                    this.classList.add('active')
                }
            })
        })
    }

    rewriteComplexity(value) {
        if (value == '1') return 'Einfach'
        if (value == '2') return 'Normal'
        if (value == '3') return 'Anspruchsvoll'
    }

    saveFilterOnRequest = filter => {
        let filterSafe = {
            'year': filter.year,
            'quarter': filter.quarter,
            'evu': filter.evu,
            'region': filter.region,
            'product_type': filter.product_type,
            'complexity': filter.complexity,
        }

        return filterSafe;
    }

    /*
    * @desc         init search option
    * */
    initSearch() {
        let filterLines = document.querySelector('#filter-lines'),
            searchInput = filterLines.querySelector('#filter-search');

        if (searchInput !== 'undefined' && searchInput !== null) {
            searchInput.addEventListener('input', function () {
                let value = this.value.toLowerCase(),
                    valueStripped = this.value.toLowerCase().replace(/ /g, ""),
                    mainLabel = filterLines.querySelectorAll('.main-label');

                if (value !== '') {
                    Array.from(mainLabel).forEach((label) => {
                        let subinputs = label.querySelectorAll('input');

                        Array.from(subinputs).forEach((input) => {
                            if (input.value.toLowerCase().includes(value) || input.value.toLowerCase().includes(valueStripped)) {
                                input.parentNode.parentNode.classList.remove('hidden')
                            } else {
                                input.parentNode.parentNode.classList.add('hidden')
                            }
                        })
                    });
                }
                //
            })
        }
    }

    countActiveFilter = filters => {
        Object.keys(filters).forEach(function (key) {
            let filterContent = filters[key];
            let filterArray = filterContent.split(',');
            let filterLength = filterArray.length;

            if (filterArray[0] !== '' && filterLength >= 1) {
                let filterElement = document.querySelector('#filter-' + key),
                    filterCounter = filterElement.querySelector('.filter-counter');

                filterCounter.innerHTML = filterLength;
                filterCounter.classList.add('active')
            } else {
                let filterElement = document.querySelector('#filter-' + key),
                    filterCounter = filterElement.querySelector('.filter-counter');

                filterCounter.innerHTML = '';
                filterCounter.classList.remove('active')
            }
        });
    }

    /*
    * @desc         add click EventListener to labels/values
    * */
    sendFilterOnChange = function() {
        let dropdowns = Array.from(document.querySelectorAll('.qm-filter__dropdown'));

        new DataTablesController().filterProcess('filter', event)

        dropdowns.forEach(dropdown => {
            let inputs = Array.from(dropdown.querySelectorAll('input[type="checkbox"], input[type="radio"]')),
                anInputOfThisDropdownIsChecked = false;

            inputs.forEach(input => {
                if (input.checked) anInputOfThisDropdownIsChecked = true
            })

            if (anInputOfThisDropdownIsChecked) {
                if (!dropdown.classList.contains('disabled')) {
                    dropdown.nextElementSibling.classList.remove('disabled')
                } else {
                    if (dropdown.nextElementSibling) dropdown.nextElementSibling.classList.add('disabled')
                }
            } else {
                if (dropdown.nextElementSibling) dropdown.nextElementSibling.classList.add('disabled')
            }
        });
    }

}
